import { ArrowDown, ArrowUp } from 'lucide-react'
import { Card, CardContent } from '~/components/ui/card'
import type { Stat } from '~/lib/types'

export default function StatTile({ stat }: { stat: Stat }) {
  return (
    <Card>
      <CardContent>
        <p className="text-sm text-ink-2">{stat.label}</p>

        <p className="mt-2 text-3xl font-semibold tracking-tight">
          {stat.format === 'percent' ? `${stat.value}%` : stat.value.toLocaleString()}
        </p>

        <div className="mt-1 flex min-h-5 flex-wrap items-center gap-x-2 text-xs">
          {stat.delta !== null && <Delta value={stat.delta} />}
          {stat.caption && <span className="text-faint">{stat.caption}</span>}
        </div>
      </CardContent>
    </Card>
  )
}

// Direction is carried by an arrow glyph and the word, not by color alone.
function Delta({ value }: { value: number }) {
  const up = value >= 0
  const Icon = up ? ArrowUp : ArrowDown

  return (
    <span className={`inline-flex items-center gap-1 ${up ? 'text-good' : 'text-critical'}`}>
      <Icon className="size-3" aria-hidden="true" />
      {Math.abs(value)}%<span className="text-faint">{up ? ' up' : ' down'} vs last month</span>
    </span>
  )
}
